<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import ut from "@/utils/utils.js";
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      geo: {}
    }
  },
  
  beforeCreate () {
    // 进入页面后先整理一些参数
    
    
  },
  created() {
    // 通道类型
        const channelType = ut.getChannelType();
        this.$store.commit("set_channelType", channelType);
  },
  mounted() {
    // 打开调试
    let debug = localStorage.getItem("debug");
		if ( debug == 1 || process.env.NODE_ENV === "development" || window.location.href.indexOf("identity2.yesno.com.cn") > -1 ) {
			var script = document.createElement('script');
        script.src = 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js';
        script.onload = function() {
          new VConsole();
        };
        document.head.appendChild(script);
		}
  },
  methods: {
  }
}
</script>

<style>
html,body  {
    height: 100%;
    font-size: 16px;
}
iframe {
  display: none;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
}

body {
    width: 100%;
    margin: 0;
    height: 100%;
    line-height: 1.2;
    font-family: "Microsoft YaHei", "Segoe UI", Verdana, Helvetica, Sans-Serif;
    /* overflow: hidden; */
}
* {
  margin: 0;
  padding: 0;
}
p {
   margin-top: 5px;
    margin-bottom: 5px;
}
</style>
